import React from 'react'
import Link from 'gatsby-link'

import Headroom from 'react-headroom'

import ResponsiveMenu from 'react-responsive-navbar'

const mastery = "devilish-passion";

var NavMenu = React.createClass({

    getInitialState: function(){
        return {
            condition:false
        }
    },

    handleClick :function(){
        this.setState( { condition : !this.state.condition } );
    },
    
    closeMenu :function(){
        this.setState( { condition : false } );
    },
    
  
    render: function() {
        return <section className="navbar-section">
          <Link to="/" className="navbar-brand" onClick={this.closeMenu}>
            <img className="navbar-logo img-full" src={require('../../images/duvel_logo.jpg')} />
          </Link>
          <div className="navbar-nav"><button className={this.state.condition ? "nav-toggle open" : "nav-toggle"} onClick={this.handleClick}><span></span></button>
          <div className={this.state.condition ? "navbar-links open" : "navbar-links"} onClick={this.closeMenu}>
          <Link to="/the-beer" className="btn btn-link" activeClassName="active">The Beer</Link>
          <Link to="/celebrating-mastery" className="btn btn-link" activeClassName="active">Celebrating Mastery</Link>
          <Link to="/since-1871" className="btn btn-link" activeClassName="active">Since 1871</Link></div></div></section>;
    }
});



var LangMenu = React.createClass({

    getInitialState: function(){
        return {
          isMouseInside: false
      };
    },

    mouseEnter :function(){
        this.setState( { isMouseInside: true } );
    },
    mouseLeave :function(){
        this.setState( { isMouseInside: false } );
    },
  
    handleClick :function(){
        this.setState( { isMouseInside : !this.state.isMouseInside } );
    },

    render: function() {
      return <div className="top-navbar-lang" onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} onClick={this.handleClick}>
          <button className="top-navbar-lang-active btn btn-link btn-light-grey">日本語</button>
          <ul className={this.state.isMouseInside ? "top-navbar-lang-list show" :"top-navbar-lang-list"}>
            <li>
              <a href="http://www.duvel.com/nl-be">België</a>
            </li>
            <li>
              <a href="http://www.duvel.com/fr-be">Belgique</a>
            </li>
            <li>
              <a href="http://www.duvel.com/nl-nl">Nederland</a>
            </li>
            <li>
              <a href="http://www.duvel.com/fr-fr">France</a>
            </li>
            <li>
              <a href="http://www.duvel.com/en-gb">United Kingdom</a>
            </li>
            <li>
              <a href="http://www.duvel.com/en-us">USA</a>
            </li>
            <li>
              <a href="http://www.duvel.com/en">International</a>
            </li>
            <li>
              <a href="http://www.duvel.com/ja" className="active">日本語</a>
            </li>
            <li>
              <a href="http://www.duvel.com/es">España</a>
            </li>
          </ul>
        </div>;
    }
});

const Header = () => (
  <Headroom>
  <header className="site-header">
    <div className="container grid-xl relative">
      <div className="top-navbar">
        <div className="top-navbar-menu">
          <Link className="btn btn-link btn-light-grey" to="/">HOME</Link>
          <Link className="btn btn-link btn-light-grey" activeClassName="active" to="/contact">CONTACT</Link>
        </div>
        <LangMenu />
        <div className="top-navbar-sns">
          <a href="http://www.facebook.com/DuvelJapan" target="_blank" className="img-sns"><img src={require('../../images/icon_fb.png')} className="img-responsive"/></a>
          <a href="https://www.instagram.com/duveljp/" target="_blank" className="img-sns"><img src={require('../../images/icon_instagram.png')} className="img-responsive"/></a>
        </div>
      </div>
      <nav className="navbar">
        <NavMenu />
      </nav>
    </div>
  </header>
</Headroom>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js